// Based on https://tympanus.net/codrops/2015/09/15/styling-customizing-file-inputs-smart-way/
let inputs = document.querySelectorAll('.file-input');
inputs.forEach(function(input) {

  let label	 = input.nextElementSibling;
  let labelVal = label.innerHTML;

  input.addEventListener('change', function(e) {
    let fileName = '';
    if (this.files && this.files.length > 1)
      fileName = (this.getAttribute('data-multiple-caption') || '').replace('{count}', this.files.length);
    else
      fileName = e.target.value.split('\\').pop();

    if (fileName)
      label.querySelector('span').innerHTML = fileName;
    else
      label.innerHTML = labelVal;
  });

  // Firefox bug fix
  input.addEventListener('focus', function() { input.classList.add('has-focus'); });
  input.addEventListener('blur', function() { input.classList.remove('has-focus'); });
});

module.exports = inputs;
